// eslint-disable-next-line import/no-cycle
import HttpClient from './http';

export const getEvent = async () => {
  try {
    const resp = await HttpClient.get('events');

    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const getEventById = async (id) => {
  try {
    const resp = await HttpClient.get(`events/${id}`);

    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const createEvent = async (data) => {
  try {
    const resp = await HttpClient.post('events/new-event', data);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const editEvent = async (data) => {
  try {
    const resp = await HttpClient.put('events/update', data);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const removeEvent = async (data) => {
  try {
    const resp = await HttpClient.delete('events/delete', { params: data });
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const createUserEvent = async (data) => {
  try {
    const resp = await HttpClient.post('user-events/new-user-event', data);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const deleteUserEvent = async (data) => {
  try {
    const resp = await HttpClient.delete('user-events/delete-user-event', {
      params: data,
    });
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const getEventsByCurrentDate = async () => {
  try {
    const resp = await HttpClient.get('events/currentDate');

    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};
